<div class="info-card" *ngIf="(message || '') != ''">
  <div class="row d-flex">
    <div class="d-inline-block p-1 pl-2">
      <mat-icon class="icon-bottom-sheet float-left">information</mat-icon>
    </div>
    <div class="d-inline-block p-4">
      {{ message }}
    </div>
  </div>
</div>
